import { createAction } from '@ngrx/store';

export const skip = createAction(
  '[NoOp] No action behind'
);
